import { render, staticRenderFns } from "./auto_market_official.vue?vue&type=template&id=a0423ad4&scoped=true"
import script from "./auto_market_official.vue?vue&type=script&lang=js"
export * from "./auto_market_official.vue?vue&type=script&lang=js"
import style0 from "./auto_market_official.vue?vue&type=style&index=0&id=a0423ad4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0423ad4",
  null
  
)

export default component.exports